import { IconProps } from '@euler/app/components/icons/types';
import { memo } from 'react';
import { StyleProp, TouchableOpacity, ViewStyle } from 'react-native';
import Svg, { Path } from 'react-native-svg';

export const RefreshIcon1 = memo(({ size = 32, color, style }: IconProps) => {
  return (
    <Svg viewBox="0 0 1024 1024" width={size} height={size} style={style}>
      <Path
        d="M819.152519 631.147634l96.728018-194.07309-50.133817-24.987091c-11.029194-41.123606-28.529777-79.745229-52.100612-114.864074-23.796986-35.456536-53.198619-66.549695-87.389326-92.414783-45.029566-34.063817-97.94166-58.238402-153.017022-69.90921-57.815777-12.251022-116.376521-11.073196-174.054151 3.498684-50.420343 12.739139-96.856955 34.987862-138.019447 66.12707-39.740096 30.062689-72.887031 67.091024-98.519828 110.056582-25.632797 42.964534-42.472324 89.722464-50.049906 138.973168-7.848759 51.013861-5.369288 102.44523 7.370875 152.865573 12.739139 50.41932 34.987862 96.855932 66.12707 138.019447 30.062689 39.739073 67.091024 72.887031 110.055558 98.518804s89.723487 42.472324 138.974191 50.048883c19.410072 2.986007 38.872333 4.476965 58.325383 4.476965 31.67235 0 63.304791-3.955078 94.54019-11.846816 65.059761-16.438391 124.847449-49.619094 172.900885-95.956446l-59.665915-61.876256c-37.290301 35.957957-83.727936 61.717643-134.291542 74.492598-160.059416 40.443108-323.183633-56.874335-363.626741-216.935798-40.442084-160.060439 56.875359-323.183633 216.936821-363.625718 88.565105-22.379707 181.205015-3.563152 254.156514 51.624774 48.568159 36.740786 83.824127 85.87381 102.941534 143.073556l-46.51336 21.233604L819.152519 631.147634z"
        fill={color}
      ></Path>
    </Svg>
  );
});

export const RefreshIcon = memo(({ size = 32, color, style }: IconProps) => {
  return (
    <Svg
      viewBox="0 0 1024 1024"
      width={size}
      height={size}
      style={style}
      fill={color}
    >
      <Path d="M1013.274531 617.561191l-157.495039-157.495039c-9.031974-9.031974-24.837927-9.031974-33.869901 0l-157.495039 157.495039c-9.031974 9.031974-7.338479 33.305402 14.112459 33.305402l116.851158 0c-47.982359 109.512679-157.495039 185.719956-283.942668 185.719956-120.802646 0-226.363837-71.126792-277.168688-173.865491L137.173098 662.721058C193.058434 816.264609 338.699008 925.777288 512 925.777288c176.687982 0 326.280044-114.593164 377.649394-274.910695l112.899669 0C1024 650.866593 1022.306505 626.028666 1013.274531 617.561191z" />
      <Path d="M512 191.364939c121.367144 0 227.492834 71.126792 278.297685 173.865491l97.093716 0C832.635061 211.122381 685.865491 101.609702 513.693495 101.609702c-176.687982 0-326.280044 114.593164-377.649394 274.910695L21.450937 376.520397c-21.450937 0-19.192944 24.837927-10.725469 33.305402l157.495039 157.495039c9.031974 9.031974 24.837927 9.031974 33.305402 0l157.495039-157.495039c9.031974-9.031974 7.338479-33.305402-14.112459-33.305402L228.057332 376.520397C276.039691 267.572216 384.987872 191.364939 512 191.364939z" />
    </Svg>
  );
});

export const RefreshButton = memo(
  ({
    iconProps,
    style,
    onPress,
  }: {
    iconProps?: IconProps;
    style?: StyleProp<ViewStyle>;
    onPress?: () => void;
  }) => {
    return (
      <TouchableOpacity
        css={`
          align-items: center;
          justify-content: center;
        `}
        style={style}
        onPress={onPress}
      >
        <RefreshIcon {...iconProps} />
      </TouchableOpacity>
    );
  },
);
